import { carrierPickupLocationMessage } from 'checkout/checkout/carrierPickupLocation/helpers';
import { requiresCarrierPickupLocation } from 'checkout/checkout/helpers';
import AddressOnlyDisplay from 'common/components/address/AddressOnlyDisplay';

const CarrierPickupLocation = (props) => {
  const { cart, currentStep, onEdit, settings } = props;
  const handleEdit = (e) => {
    e.preventDefault();
    onEdit('carrierPickupLocation');
  };
  if (!requiresCarrierPickupLocation(cart, settings)) {
    return null;
  }
  if (
    currentStep === 'shipping' ||
    currentStep === 'payment' ||
    currentStep === 'complete'
  ) {
    if (cart.carrierPickupLocation) {
      return (
        <>
          <div>
            <div>
              <div>Local Pickup Location</div>
              <div>
                <AddressOnlyDisplay address={cart.carrierPickupLocation} />
              </div>
            </div>
            <a href="#" aria-label="Edit" onClick={handleEdit}>
              Edit
            </a>
          </div>
        </>
      );
    }
    return (
      <>
        <div>
          <div>
            <div>Local Pickup Location</div>
            <div>{carrierPickupLocationMessage(settings)}</div>
          </div>
          <a href="#" aria-label="Edit" onClick={handleEdit}>
            Edit
          </a>
        </div>
      </>
    );
  }
  return null;
};

export default CarrierPickupLocation;
